// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'exchange';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M9.563.563h3.374a2.25 2.25 0 0 1 2.25 2.25v2.25' />
    <path d='m13.5 3.375 1.688 1.688 1.687-1.688m-9 14.063H4.5a2.25 2.25 0 0 1-2.25-2.25v-2.25' />
    <path d='M3.938 14.625 2.25 12.937.562 14.626m13.501-3.938h-1.5a1.004 1.004 0 0 0-.375 1.942l1.545.615a1.02 1.02 0 0 1 .637.938 1.004 1.004 0 0 1-1.012 1.005h-1.5m1.08-4.5v-.563m0 5.625v-.563' />
    <path d='M12.938 17.438a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9zm-6.75-15v3.187a.57.57 0 0 1-.563.563H2.25a.563.563 0 0 1-.563-.563V2.437' />
    <path d='M.563 3.375 3.938.562l3.374 2.813' />
  </g>
);

export const viewBox = '0 0 18 18';
